/** Apply a historical BOM. When the sheet already has content: replace / add below / cancel (偏差 D6 — the original had no cancel). */
import type { Lang } from "@ic/engine";
import { useStore } from "../../store.ts";
import { okToReplace } from "../../shared/unsaved.ts";
import { useT, tFor } from "../../shared/i18n.ts";
import { api } from "../../shared/api.ts";
import { Modal } from "../../shared/ui/common.tsx";
import { myCoef } from "../cost-sheet/coef.ts";

export async function applyBomTo(sc: string, mode: "replace" | "add", lang: Lang, only?: number[]) {
  const { sheet, setSheet, go, toast } = useStore.getState();
  const t = tFor(lang);
  if (mode === "replace" && !okToReplace()) return;
  try {
    const r = await api.applyBom(sc, sheet, mode, lang, myCoef(), only);
    setSheet(r.sheet, mode === "replace" ? { id: null } : undefined);
    if (mode === "replace") useStore.getState().markSaved(r.sheet); // a fresh copy of history: nothing to lose yet
    go("sheet");
    toast(only ? t(`Added ${only.length} row(s) from `, `已追加 ${only.length} 行，来自 `) + sc : t("Applied BOM from ", "已套用 BOM：") + sc);
  } catch (e) { toast(e instanceof Error ? e.message : String(e)); }
}

export function ApplyDialog({ sc }: { sc: string }) {
  const t = useT();
  const lang = useStore((s) => s.lang);
  const close = useStore.getState().closeModal;
  const pick = (mode: "replace" | "add") => { close(); applyBomTo(sc, mode, lang); };
  return (
    <Modal onClose={close}>
      <h3>{t("Use the BOM of ", "使用 BOM：")}{sc}</h3>
      <p className="dim" style={{ margin: 0 }}>{t("The cost sheet already has lines. Replace them, or add this BOM's lines below?", "当前 cost sheet 已经有内容。替换掉，还是把这个 BOM 的行加在下面？")}</p>
      <div className="mb3">
        <button className="btn" id="applyCancel" onClick={close}>{t("Cancel", "取消")}</button>
        <button className="btn" id="applyAdd" onClick={() => pick("add")}>{t("Add below", "追加到下面")}</button>
        <button className="btn p" id="applyReplace" onClick={() => pick("replace")}>{t("Replace", "替换")}</button>
      </div>
    </Modal>
  );
}
